import AppleSVG from '@public/icons/apple.svg';
import GooglePlaySVG from '@public/icons/google-play.svg';
import TnfSunburstSVG from '@public/icons/opened-menu-logo.svg';
import RuStoreSVG from '@public/icons/rustore.svg';
import classNames from 'classnames';
import Link from '@/shared/components/shared/Link';
import Typografed from '@/shared/components/shared/Typografed';

const STORE_ICONS = {
    'google-play': GooglePlaySVG,
    'app-store': AppleSVG,
    rustore: RuStoreSVG,
};

export type ApplicationsSectionStore = {
    name: string;
    href: string;
    icon: keyof typeof STORE_ICONS;
};

export type ApplicationsSectionProps = {
    title: string;
    description: string;
    stores: ApplicationsSectionStore[];
};

type Props = React.HTMLAttributes<HTMLElement> & {
    applicationsSectionProps: ApplicationsSectionProps;
};

const ApplicationsSection = ({ applicationsSectionProps, ...props }: Props) => {
    const { title, description, stores } = applicationsSectionProps;

    return (
        <section {...props} className={classNames('applications-section', props.className)}>
            <div className="wrapper">
                <div className="applications-section__banner">
                    <div className="applications-section__info">
                        <div className="applications-section__logo">
                            <TnfSunburstSVG aria-hidden />
                        </div>
                        <div className="applications-section__text">
                            <h2 className="applications-section__title h3">
                                <Typografed>{title}</Typografed>
                            </h2>
                            {description && (
                                <p className="applications-section__description text-m">
                                    <Typografed>{description}</Typografed>
                                </p>
                            )}
                        </div>
                    </div>
                    {stores.length > 0 && (
                        <ul className="applications-section__list list-unstyled">
                            {stores.map((store) => {
                                const Icon = STORE_ICONS[store.icon];

                                return (
                                    <li key={store.name} className="applications-section__item">
                                        <Link
                                            href={store.href}
                                            target="_blank"
                                            rel="noreferrer nofollow"
                                            className="applications-section__store text-l"
                                        >
                                            <Icon aria-hidden />
                                            <Typografed>{store.name}</Typografed>
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>
            </div>
        </section>
    );
};

export default ApplicationsSection;
